/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDevourStatsResponseData } from './GetDevourStatsResponseData';
import {
    GetDevourStatsResponseDataFromJSON,
    GetDevourStatsResponseDataFromJSONTyped,
    GetDevourStatsResponseDataToJSON,
    GetDevourStatsResponseDataToJSONTyped,
} from './GetDevourStatsResponseData';

/**
 * 
 * @export
 * @interface GetDevourStatsResponse
 */
export interface GetDevourStatsResponse {
    /**
     * 
     * @type {GetDevourStatsResponseData}
     * @memberof GetDevourStatsResponse
     */
    data?: GetDevourStatsResponseData;
}

/**
 * Check if a given object implements the GetDevourStatsResponse interface.
 */
export function instanceOfGetDevourStatsResponse(value: object): value is GetDevourStatsResponse {
    return true;
}

export function GetDevourStatsResponseFromJSON(json: any): GetDevourStatsResponse {
    return GetDevourStatsResponseFromJSONTyped(json, false);
}

export function GetDevourStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDevourStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : GetDevourStatsResponseDataFromJSON(json['data']),
    };
}

export function GetDevourStatsResponseToJSON(json: any): GetDevourStatsResponse {
    return GetDevourStatsResponseToJSONTyped(json, false);
}

export function GetDevourStatsResponseToJSONTyped(value?: GetDevourStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': GetDevourStatsResponseDataToJSON(value['data']),
    };
}

